import 'leaflet'
import store from "@/store";

// Определяем, используется ли китайский режим (AMap), чтобы подобрать контрастные цвета
const urlParams = new URLSearchParams(window.location.search);
const isChinaMode = navigator.language.startsWith('zh') || 
                    urlParams.has('china') || 
                    window.location.hostname.endsWith('ecdis-link.net');

// Для спутниковых карт (AMap) и морских карт подбираем универсальный заметный цвет
// Ярко-оранжевый/золотистый цвет (#FFD700 или #FFA500) обычно хорошо виден и на темном спутнике, и на голубой воде.
const DEFAULT_CELL_COLOR = isChinaMode ? '#FFD700' : 'black'
const ACTIVE_CELL_COLOR = 'lightgreen'
const SELECTED_CELL_COLOR = '#ff9001'
const DISABLED_CELL_COLOR = 'magenta'

const ACTIVE_STYLE = {color: ACTIVE_CELL_COLOR, fillOpacity: 0.5}
const DEFAULT_STYLE = {
    color: DEFAULT_CELL_COLOR, 
    fillOpacity: 0.05, 
    weight: isChinaMode ? 2 : 1, 
    opacity: 1
};
export const SELECTED_STYLE = {color: SELECTED_CELL_COLOR, weight: 4, opacity: 1, fillOpacity: 0.2}
export const DISABLED_SELECTED_STYLE = {color: DISABLED_CELL_COLOR, weight: 2, opacity: 0.5, fillOpacity: 0.1}
const defaultOptions = {cell : undefined, id: undefined, isSelected : undefined, cellObj: undefined , nativeBand: undefined, disabled: undefined}
let activeCell = defaultOptions
let tmpCell = defaultOptions
let activePane
let chartsLayers
let chartsData
let reorderSelectedCells

const init = (pane, chartLayers, chartData, reorderSelectedCellsCallback) =>{
    getLayers(chartLayers, chartData);
    setActivePane(pane);
    reorderSelectedCells = reorderSelectedCellsCallback;
}
const getLayers = (chartLayers, chartData) => {
  chartsLayers = chartLayers;
  chartsData = chartData;
}
const removeFromActivePane = (cell) => {
    cell.cellObj.removeFrom(activePane)
    cell.cellObj.addTo(activeCell.isSelected ? chartsData.selectedCells.lg : chartsLayers[activeCell.nativeBand]);
    if (activeCell.isSelected && reorderSelectedCells) {
        reorderSelectedCells()
    }
}
const addToActivePane = (cell) => {
    cell.cellObj.removeFrom(chartsLayers[activeCell.nativeBand])
    cell.cellObj.addTo(activePane);
}
const changeActiveCell = (cell, id, isSelected, cellObj, nativeBand, disabled) =>{

    if (activeCell.id) {

        activeCell.cell.setStyle(!activeCell.disabled && activeCell.isSelected ? SELECTED_STYLE : DEFAULT_STYLE);
        removeFromActivePane(activeCell)
    }
    tmpCell.id = id;
    tmpCell.cell = cell;
    tmpCell.cellObj = cellObj
    tmpCell.isSelected = isSelected
    tmpCell.nativeBand = nativeBand
    tmpCell.disabled = disabled
    // tmpCell.cell.bringToFront();
    console.log(tmpCell.id, activeCell.id, 'cc')
    Object.assign(activeCell, tmpCell);
    tmpCell = defaultOptions
    console.log(tmpCell.id, activeCell.id, 'cc', '2')
    addToActivePane(activeCell)
    activeCell.cell.setStyle(ACTIVE_STYLE);

}
const syncSelectedStatus = (id, sts, cell, disabled) => {
    console.log(id, activeCell.id, 'otk')
    if (id === activeCell.id) {
        activeCell.isSelected = sts
        activeCell.disabled = disabled
        if (disabled){
            activeCell.cell.setStyle(DEFAULT_STYLE)
        }
        else{
            activeCell.cell.setStyle(ACTIVE_STYLE)
        }
        addToActivePane(activeCell)
    }
    else if (!disabled ){
        console.log(disabled, id, 'otk')
        cell.setStyle(SELECTED_STYLE)
    }
    else if (disabled){
        console.log(disabled, id, 'otk')
        cell.setStyle(DISABLED_SELECTED_STYLE)
    }

}
const setActivePane = (pane) => {
    activePane = pane;
}
export {DEFAULT_CELL_COLOR,
    SELECTED_CELL_COLOR,
    ACTIVE_CELL_COLOR,
    DEFAULT_STYLE,
    ACTIVE_STYLE,
    changeActiveCell,
    syncSelectedStatus,
    init
}